import React, { useEffect, useRef, useState } from "react";

import "./gallery.scss";
import { observer } from "mobx-react-lite";
import Header from "../../components/header/header";
import GalleryPhoto from "./photo/photo";
import GalleryVideo from "./video/video";
import SliderOfAges from "../../components/slider_of_ages/slider_of_ages";

type TabsType = "photo" | "video";

function GalleryPage() {
	const [currentTab, changeCurrentTab] = useState<TabsType>("photo");

	useEffect(() => {
		document.title = "Галерея";
	});

	return (
		<>
			<div className="menu">
				<div
					className={
						"photo item " + (currentTab === "photo" ? "active" : "")
					}
					onClick={() => changeCurrentTab("photo")}
				>
					Фото
				</div>
				<div
					className={
						"photo item " + (currentTab === "video" ? "active" : "")
					}
					onClick={() => changeCurrentTab("video")}
				>
					Видео
				</div>
			</div>

			{currentTab === "photo" && <GalleryPhoto></GalleryPhoto>}
			{currentTab === "video" && <GalleryVideo></GalleryVideo>}

			<div className="footer_wrapper">
				<SliderOfAges></SliderOfAges>
			</div>
		</>
	);
}

export default observer(GalleryPage);
